module.exports = __webpack_public_path__ + "img/recolumn_example1.f560a56a.png";